var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductCostsFormDrawer',{ref:"ProductCostsFormDrawer",attrs:{"value":_vm.form.product_variants[0]},on:{"input":function($event){return _vm.handleSave($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }